import React, { Component } from "react";
import { ComboBox } from "../../ComboBox";

export class ModalMessageUser extends Component {

    constructor(props) {
        super(props);
        this.state = { newData: [], isTask: false };
    }

    componentDidMount() {
        if (true) {

        }
    }

    componentDidUpdate() {
        if (this.props && this.state.newData) {
            this.setState({ newData: this.props.data })
        }
    }

    async saveComment() {

        let parentUsers = [];
        document.querySelectorAll('#ComboWrappUsers ul li input:checked').forEach((e, i) => {
            parentUsers.push({ Id: parseInt(e.value) })
        })

        if (!document.querySelector('textarea[name=messageComment]').value || (document.querySelector('input[name=createTask]').checked && (!document.querySelector('input[name=dateTask]').value || parentUsers.length == 0))) {
            alert("Los campos marcados con (*) son obligatorios.")
            return false;
        }

        var model = {
            ClientId: parseInt(document.querySelector('input[name=clientId]').value),
            Process: document.querySelector('select[name=messageProccess]').value,
            Comment: document.querySelector('textarea[name=messageComment]').value,
            CreateTask: document.querySelector('input[name=createTask]').checked
        };

        if (model.CreateTask) {
            model.DateTask = document.querySelector('input[name=dateTask]').value;
            model.Users = parentUsers;
        }

        document.querySelector('#status').innerHTML = "Por favor espere...";

        var request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(model)
        }

        var response = await fetch('AdminRegisteredUsers/AddComment', request);

        if (response.redirected) {
            window.location.href = response.url;
        }

        if (response.status == 200) {
            document.querySelector('#status').innerHTML = "Guardado con éxito.";
        } else {
            document.querySelector('#status').innerHTML = "Error, por favor inténtelo más tarde.";
        }
        var data = await response.json();
        document.querySelector('textarea[name=messageComment]').value = '';
        if (document.querySelector('input[name=createTask]').checked) {
            document.querySelector('input[name=dateTask]').value = '';
        }
        document.querySelector('input[name=createTask]').checked = false;

        this.props.data.push({ id: 0, user: data.user, process: data.process, createOnDate: data.createOnDate, comment: data.comment });
        this.setState({ newMessage: this.props.data, isTask: false });

    }

    render() {
        if (this.state.newData > this.props.data) {
            alert();
        } else {
            return (
                <div>
                    <button id="openModalMessage" type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalMessage" hidden>
                        Launch demo modal
                    </button>

                    <div class="modal fade" id="modalMessage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">Mensajes</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body messages">
                                    <input type="hidden" value={this.props.clientId} name="clientId" />
                                    {this.props.data ? this.props.data.map(e => <div className="item">

                                        <input type="hidden" value={e.id} name="id" />
                                        <label>{e.user}</label>
                                        <span>{e.process} - {e.createOnDate}</span>
                                        <p>{e.comment}</p>

                                    </div>) : <h4>Cargando...</h4>}


                                    {this.state.newMessage > 0 ? this.state.newMessage.map(e => <div className="item">

                                        <input type="hidden" value={e.id} name="id" />
                                        <label>{e.user}</label>
                                        <span>{e.process} - {e.createOnDate}</span>
                                        <p>{e.comment}</p>

                                    </div>) : null}

                                </div>
                                <div className="modal-body form">
                                    <div className="form-group">
                                        <select className="form-control" name="messageProccess">
                                            <option value="Básico">Básico</option>
                                            <option value="Avanzado">Avanzado</option>
                                            <option value="PL">PL</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>* Comentario</label>
                                        <textarea className="form-control" maxLength="255" name="messageComment" />
                                    </div>
                                    <div className="form-group">
                                        <label for="createTask">
                                            <input type="checkbox" id="createTask" name="createTask" value="task" onClick={(e) => {
                                                this.setState({ isTask: e.currentTarget.checked })
                                            }} />
                                            Crear tarea
                                        </label>
                                    </div>
                                    {
                                        this.state.isTask ? <div className="form-group">
                                            <label>* Fecha para finalizar tarea</label>
                                            <input type="datetime-local" name="dateTask" className="form-control" />
                                        </div> : null
                                    }
                                    {
                                        this.state.isTask ? <div className="form-group">
                                            <label>* Usuario responsable</label>
                                            <ComboBox data={this.props.Users} id="ComboWrappUsers" lot={true}></ComboBox>
                                        </div> : null
                                    }
                                    <div className="form-group">
                                        <span id="status"></span>
                                    </div>
                                    <div className="form-group">
                                        <input type="button" className="btn btn-primary" value="Guardar" onClick={() => this.saveComment()} />
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            )
        }
    }
}